import { createContext } from 'react';

export const CertificationGoalContext = createContext<GoalFieldsContextValue>({
  fields: {},
  report: () => {},
});
